import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import FormLicenseTemplate from './form-license-template';
import { createMessage } from 'works/legacy/lib/message-helper';
import { UpdateLicenseItemTemplate } from 'works/graphql/works-list-item-template';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';
export default function EditLicenseTemplate({ dismiss, item, form }) {
  const handleMutationCompletion = (response) => {
    if (response.updateLicenseItemTemplate.errors) {
      addErrorsToForm(form, response.updateLicenseItemTemplate.errors);

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item updated!');
      dismiss();
    }
  };

  const [updateLicense] = useMutation(UpdateLicenseItemTemplate, {
    onCompleted: handleMutationCompletion,
    onError: () =>
      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      ),
  });

  const handleSubmit = (values) => {
    updateLicense({
      variables: {
        itemId: item.id,
        input: values,
      },
    });
  };

  const initialValues = {
    licenseType: item.licenseType,
    active: item.active,
    name: item.name,
    description: item.description,
    expirationType: item.expirationType,
    daysToExpiry: item.daysToExpiry,
  };

  return (
    <FormLicenseTemplate
      initialValues={initialValues}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      showExpiration
      form={form}
    />
  );
}

EditLicenseTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
};
